import { render, staticRenderFns } from "./BLangSelector.vue?vue&type=template&id=8889a3be&"
import script from "./BLangSelector.vue?vue&type=script&lang=js&"
export * from "./BLangSelector.vue?vue&type=script&lang=js&"
import style0 from "./BLangSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports